import { ReportChartConfiguration } from '@vision/ui/interfaces';
import { array, string } from 'yup';
import { PieChart2CompareRenderer } from '../../components';
import { PieChart2ValueComponent } from '../../components/ReportsDetailGraphicChartsRenderer';
import {
  DefaultReportChartThemeFont,
  DefaultReportChartThemeSeries,
  extendDefaultChartValidationSchema,
} from '../default-chart.config';
import { PieChart2Measures } from './pie-chart2.measures';

export const PieChart2DefaultConfiguration: ReportChartConfiguration = {
  supportsLegendSettings: true,
  validationSchema: extendDefaultChartValidationSchema({
    params: {
      selectedCompare: array().of(string()).min(2, 'validation:rules.generic.required'),
    },
  }),
  measures: PieChart2Measures,
  compareRendererComponent: PieChart2CompareRenderer,
  responseMultiple: true, // Two compare and one measure requested by the client
  hideCompare: true,
  chartValueComponent: PieChart2ValueComponent,
  measureHeader: {
    labelKey: 'page-reports:measurement',
    showIcon: false,
  },
  requestType: 'MultipleCompare',
  customize: {
    active: (values) => values.selectedMeasure && values.selectedCompare.length > 1,
    transactionalDate: {
      active: false,
    },
    feedbackCount: {
      active: false,
    },
    limits: {
      upperLimitActive: false,
      upperLimit: 0,
      lowerLimitActive: false,
      lowerLimit: 0,
    },
  },
  defaultTheme: {
    active: (values) => values.selectedMeasure && values.selectedCompare.length > 1,
    title: {
      ...DefaultReportChartThemeFont,
      label: '',
    },
    series: {
      ...DefaultReportChartThemeSeries,
    },
  },
};
